// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.eK9MB9rMoxBwwZx7YgPQ {
  align-items: center;
  display: grid;
  grid-template-columns: 1fr 1fr;
  justify-content: center;
  height: 100%;
  width: 100%;
}

.EsUgnGPZUbKjt1CWGvQm {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  height: 100%;
  justify-content: center;
}

.EsUgnGPZUbKjt1CWGvQm:not(:last-child) {
  border-right: 1px solid #ccc;
}

.MMc80g17DmLZcb0id5IA {
  font-size: 12px;
  font-weight: 700;
  text-align: center;
}

.xKySgQADoZRVjAK1v0K1 {
  font-size: 20px;
  font-weight: 700;
}

.PG4_cVZPfUlhagakDU3S {
  font-size: 12px;
  font-weight: 700;
}

.DznyLrj5uVmQ6sgyIsdA {
  font-size: 20px;
  font-weight: 700;
}

.LUmcvpp2vqS6HanRRh5t {
  font-size: 12px;
  font-weight: 700;
}`, "",{"version":3,"sources":["webpack://./tcbase/static/js2/modules/samples/components/header/detections/detections.module.scss"],"names":[],"mappings":"AACA;EACE,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;AAAF;;AAGA;EACE,4BAAA;AAAF;;AAGA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,eAAA;EACA,gBAAA;AAAF;;AAGA;EACE,eAAA;EACA,gBAAA;AAAF;;AAGA;EACE,eAAA;EACA,gBAAA;AAAF;;AAGA;EACE,eAAA;EACA,gBAAA;AAAF","sourcesContent":["@import \"/tcbase/static/style/settings/settings.rl.variables.scss\"; @import \"/tcbase/static/style/settings/settings.bs.variables.scss\";\n.detections {\n  align-items: center;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  justify-content: center;\n  height: 100%;\n  width: 100%;\n}\n\n.detections_section {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  height: 100%;\n  justify-content: center;\n}\n\n.detections_section:not(:last-child) {\n  border-right: 1px solid #ccc;\n}\n\n.detections_section_title {\n  font-size: 12px;\n  font-weight: 700;\n  text-align: center;\n}\n\n.detections_multi_scanner_matches {\n  font-size: 20px;\n  font-weight: 700;\n}\n\n.detections_multi_scanner_count {\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.detections_yara_matches {\n  font-size: 20px;\n  font-weight: 700;\n}\n\n.detections_yara_files_label {\n  font-size: 12px;\n  font-weight: 700;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"detections": `eK9MB9rMoxBwwZx7YgPQ`,
	"detections_section": `EsUgnGPZUbKjt1CWGvQm`,
	"detections_section_title": `MMc80g17DmLZcb0id5IA`,
	"detections_multi_scanner_matches": `xKySgQADoZRVjAK1v0K1`,
	"detections_multi_scanner_count": `PG4_cVZPfUlhagakDU3S`,
	"detections_yara_matches": `DznyLrj5uVmQ6sgyIsdA`,
	"detections_yara_files_label": `LUmcvpp2vqS6HanRRh5t`
};
export default ___CSS_LOADER_EXPORT___;
